import { useNavigate } from 'react-router-dom';

export default function usePlansNavigator() {

  const navigate = useNavigate();

  const openPlansPage = () => {
    navigate('/plans');
  }

  const openPlanPage = (planId: number) => {
    navigate(`/plans/${planId}`);
  }

  return {
    openPlansPage,
    openPlanPage,
  }
}
